export const SHOW_ALL_TAG = { id: "$ALL$", text: "Show All" };
